module.exports = __webpack_public_path__ + "img/contact.19ec9dfd.svg";